<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-form ref="form" :model="form" label-width="120px" >
						<h4>详细内容</h4>
						<el-form-item  style="margin-top: 40px;">
							<editor v-model="form.detail" :isClear="isClear" @change="change"></editor>
						</el-form-item>
						<div class="line"></div>
						<el-form-item label="描述" style="margin-top: 20px;">
							<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" placeholder="请输入内容" v-model="form.desc">
							</el-input>
						</el-form-item>
						<el-form-item>
							<input  type="button" @click="onSubmit" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import E from "wangeditor";
	import Editor from '../../../components/tinymce.vue'
	export default {
		components: {
			Editor
		},
		data() {
			return {
				form: {
					desc:'',
					detail:'',
					id:''
				},
				isClear: false,
				editorText:'',
			}
		},
		watch:{
		  '$route.query':{
		    handler(query){
		      let path = this.$route.path;
			  this.loading  = true
		       this.getData()
		    }
		  },
		
		},
		mounted() {

		},
		created() {
			this.getData()
		},
		methods: {
			change(val) {
				console.log(val)

			},
			onSubmit() {
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/show/update',
					data: {
						 
						cid:this.$route.query.id,
						id:this.form.id,
						content:this.form.detail,
						brief:this.form.desc
					},
				}).then((res) => {
					if (res.data.status == 200) {
						obj.$message.success('修改成功')
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			getData(){
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/show/get',
					params: {
						 
						cid:this.$route.query.id
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.form.detail = res.data.data.show.content
						this.form.desc = res.data.data.show.brief
						this.form.id = res.data.data.show.id
					} else {
						obj.$message.error(res.data.message)
					}
				})
			}
			

		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 30px;
	}

	/deep/ .el-input__inner {
		height: 30px !important;
	}

	/deep/ .el-form-item__label {
		width: 36px;
		height: 17px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
	}

	.line {
		width: 100%;
		height: 1px;
		background: #000000;
		opacity: 0.3;
	}
</style>



// WEBPACK FOOTER //
// src/views/content/introduction/company.vue